<sdc-bo-dialog
  headerTitle="Are you sure you want to delete this event?"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'event-delete-modal-' + data()?.id">
  <div class="content-wrapper">
    <div>
      <div class="input-line">
        <div>
          <span><b>Code</b></span>
        </div>
        <div>
          <p>{{ data()?.code }}</p>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Description</b></span>
        </div>
        <div>
          <p>{{ data()?.description }}</p>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Date</b></span>
        </div>
        <div>
          <p>{{ data()?.date | date }}</p>
        </div>
      </div>
    </div>
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="secondary" (onClick)="onDismiss()">Cancel</sdc-button>
    <sdc-button variant="destructive" (onClick)="onConfirm(data()?.id)">
      Permanently delete
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
